/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TaskInstructionCreateRequest } from '../models/TaskInstructionCreateRequest';
import type { TaskInstructionResponse } from '../models/TaskInstructionResponse';
import type { TaskName } from '../models/TaskName';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InstructionsRoutesRepository {
  /**
   * Get Task Instructions
   * Fetch the most recent instructions for the specified task from each opted-in program.
   *
   * Details:
   * - Returns instructions only from programs that both include the given task and are listed in opted_in_program_id.
   * - Raises a 404 HTTPException if the specified task does not exist.
   * @returns TaskInstructionResponse Successful Response
   * @throws ApiError
   */
  public static instructionsRoutesGetTaskInstructions({
    taskName,
    programId,
    authorization,
  }: {
    taskName: TaskName,
    programId: Array<string>,
    authorization?: string,
  }): CancelablePromise<Array<TaskInstructionResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/instructions/{task_name}',
      path: {
        'task_name': taskName,
      },
      headers: {
        'authorization': authorization,
      },
      query: {
        'program_id': programId,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Task Instruction
   * Creates a new instruction for a specific task within a given program.
   *
   * This asynchronous function validates that the provided task exists and is included in the specified program.
   * If the task is part of the program, it creates a new instruction associated with the task, program, and current user.
   * If the task is not found in the program, it raises an HTTP 404 exception.
   * @returns TaskInstructionResponse Successful Response
   * @throws ApiError
   */
  public static instructionsRoutesCreateTaskInstruction({
    requestBody,
    authorization,
  }: {
    requestBody: TaskInstructionCreateRequest,
    authorization?: string,
  }): CancelablePromise<TaskInstructionResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/instructions',
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
}
